import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getFirebase } from "react-redux-firebase";
// import Agenda from "./Agenda";

import {
  Accordion,
  Divider,
  Grid,
  Header,
  Icon,
  Image,
  Label,
  Message,
  Menu,
  Segment,
} from "semantic-ui-react";

import AddMember from "../layout/AddMember";

const panel = [
  {
    key: "n",
    title: "Notifications",
    content: {
      content: <>Notifications</>,
    },
  },
  { key: "r", title: "Recent Activities", content: "Recent Activities" },
  {
    key: "t",
    title: "Recent Activities of Team",
    content: "Recent Activities of Team",
  },
];

const panels = [
  {
    key: "tools",
    title: {
      content: (
        <Label
          size="big"
          color="blue"
          style={{ width: "95%" }}
          content="Immigration Tools"
        />
      ),
    },
    content: {
      content: (
        <Message
          header="Please select the tool you want to use"
          content={
            <Grid stackable columns={2} style={{ marginTop: "5px" }}>
              <Grid.Column>
                <Segment>
                  <Image
                    as={Link}
                    to="/auto-fill"
                    style={{ cursor: "pointer" }}
                    content={<Icon circular size="huge" name="edit" />}
                    circular
                    centered
                  />
                  <Divider />
                  <Header>Auto Fill Tool</Header>
                </Segment>
              </Grid.Column>
              <Grid.Column>
                <Segment textAlign="center">
                  <Image
                    as={Link}
                    to="/legal-search"
                    style={{ cursor: "pointer" }}
                    content={<Icon circular size="huge" name="search" />}
                    circular
                    centered
                  />
                  <Divider />
                  <Header>Legal Search Tool</Header>
                </Segment>
              </Grid.Column>
            </Grid>
          }
        />
      ),
    },
  },
  // {
  //   key: "agenda",
  //   title: {
  //     content: (
  //       <Label
  //         size="big"
  //         color="blue"
  //         style={{ width: "95%" }}
  //         content="Agenda"
  //       />
  //     ),
  //   },
  //   content: {
  //     content: (
  //       <Message>
  //         <Agenda />
  //       </Message>
  //     ),
  //   },
  // },
];

function Main() {
  const firebase = getFirebase();
  const db = firebase.firestore();
  const user = firebase.auth().currentUser;
  const [authorized, setAuthorized] = useState(true);
  useEffect(() => {
    db.collection("profile")
      .doc(user.uid)
      .get()
      .then((doc) => {
        if (doc.exists) {
          if (doc.data().authority !== "Collaborator") {
            setAuthorized(false);
          }
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid stackable columns={1} padded centered>
      <Grid.Column width={10} textAlign="center">
        <Segment>
          <Accordion
            defaultActiveIndex={[0, 1]}
            exclusive={false}
            panels={panels}
          />
        </Segment>
      </Grid.Column>
    </Grid>
  );
  // if (authorized) {
  //   return (
  //     <Grid stackable columns={1} padded centered>
  //       <Grid.Column width={10} textAlign="center">
  //         <Segment>
  //           <Accordion
  //             defaultActiveIndex={[0, 1]}
  //             exclusive={false}
  //             panels={panels}
  //           />
  //         </Segment>
  //       </Grid.Column>
  //     </Grid>
  //   );
  // } else {
  //   return (
  //     <Grid stackable columns={3} padded>
  //       <Grid.Column width={4}>
  //         <Segment>
  //           <AddMember />
  //         </Segment>
  //       </Grid.Column>
  //       <Grid.Column width={9} textAlign="center">
  //         <Segment>
  //           <Accordion
  //             defaultActiveIndex={[0, 1]}
  //             exclusive={false}
  //             panels={panels}
  //           />
  //         </Segment>
  //       </Grid.Column>
  //       <Grid.Column width={3}>
  //         <Segment>
  //           <Accordion
  //             as={Menu}
  //             style={{ padding: "15px" }}
  //             vertical
  //             defaultActiveIndex={[0]}
  //             panels={panel}
  //             exclusive={false}
  //             fluid
  //           />
  //         </Segment>
  //       </Grid.Column>
  //     </Grid>
  //   );
  // }
}

export default Main;
